import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const object = vnObject

const particularForm = $('.js-particular-contact')

if (particularForm.length) {
    particularForm.parsley().on('form:success', function () {
        particularForm.attr('data-success', 'true')
    })

    particularForm.parsley().on('form:error', function () {
        particularForm.attr('data-success', 'false')
    })

    particularForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(particularForm[0])
        formData.append('action', 'vn_particular_contact')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)
                res.success && $form[0].reset()
            },
        })
    })
}

const enterpriseForm = $('.js-enterprise-contact')

if (enterpriseForm.length) {
    enterpriseForm.parsley().on('form:success', function () {
        enterpriseForm.attr('data-success', 'true')
    })

    enterpriseForm.parsley().on('form:error', function () {
        enterpriseForm.attr('data-success', 'false')
    })

    enterpriseForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(enterpriseForm[0])
        formData.append('action', 'vn_enterprise_contact')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)
                res.success && $form[0].reset()
            },
        })
    })
}

document.addEventListener('DOMContentLoaded', (event) => {
    const hash = window.location.hash;
    if (hash) {
        const tabButton = document.querySelector(`button[data-bs-target="${hash}"]`);
        tabButton.click()
    }
});
